var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import styled from "styled-components";
import { debounce } from "lodash";
import authentication from "@irati/auth";
import id from "@irati/utils/id";
import Icon from "@irati/ui/src/Icon";
import { getPlaceSuggestions } from "@irati/geolocation/src/helpers/places";
import { greys } from "@irati/ui/src/global/colors";
import { injectIntl } from "@irati/utils/lang";
import { getCurrentPosition } from "@irati/geolocation/src/helpers/devicePosition";
import CustomRenderer from "./CustomRenderer";
import StyledSelect from "./styled/Select";
var InverseGeoPin = styled(Icon)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  stroke: ", ";\n"], ["\n  stroke: ", ";\n"])), greys.black);
export var SELECTED_VALUE_ICON = React.createElement(InverseGeoPin, { color: greys.white, icon: "geoPin", size: 14 });
var GeoInput = /** @class */ (function (_super) {
    __extends(GeoInput, _super);
    function GeoInput(props) {
        var _this = _super.call(this, props) || this;
        _this.componentDidUpdate = function () {
            if (_this.props.value && !_this.state.value) {
                _this.setState({
                    value: _this.props.value
                });
            }
        };
        _this.handleChange = function (selection) {
            var _a = _this.props, onChange = _a.onChange, formatMessage = _a.formatMessage, useCurrentPositionFallback = _a.useCurrentPositionFallback;
            if (!selection) {
                return _this.setState({
                    value: {}
                });
            }
            if (selection.latLng) {
                _this.setState({ value: selection });
                return onChange({
                    latLng: selection.latLng,
                    isAccurate: true,
                    desc: selection.label
                });
            }
            _this.showFetchingLocationIndicator();
            getCurrentPosition({ useFallback: useCurrentPositionFallback })
                .then(function (pos) {
                _this.hideFetchingLocationIndicator();
                var myCurrentLocationLabel = formatMessage({ id: "geolocation.components.geoInput.label.myCurrentLocation" });
                var currentPosItem = {
                    latLng: pos.latLng,
                    label: myCurrentLocationLabel,
                    icon: SELECTED_VALUE_ICON
                };
                _this.setState({ value: currentPosItem });
                onChange({
                    latLng: currentPosItem.latLng,
                    isAccurate: !pos.isFallback,
                    desc: myCurrentLocationLabel
                });
            })
                .catch(function () {
                _this.hideFetchingLocationIndicator();
                _this.setState({
                    value: {
                        label: formatMessage({ id: "geolocation.components.geoInput.label.getBrowserCurrentPositionError" }),
                        icon: React.createElement(Icon, { color: greys.black, icon: "info", size: 16 })
                    }
                });
            });
        };
        _this.showFetchingLocationIndicator = function () {
            _this.setState({ isFetchingLocation: true });
        };
        _this.hideFetchingLocationIndicator = function () {
            _this.setState({ isFetchingLocation: false });
        };
        _this.loadOptions = function (query) {
            if (query) {
                _this.showFetchingLocationIndicator();
                var userLatLng = _this.props.userLatLng;
                var locale = authentication.userLocale();
                getPlaceSuggestions(query, userLatLng, [locale]).then(function (data) {
                    _this.hideFetchingLocationIndicator();
                    var suggestions = data.map(function (suggestion) {
                        var label = suggestion.desc;
                        var icon = SELECTED_VALUE_ICON;
                        return {
                            label: label,
                            icon: icon,
                            value: {
                                latLng: {
                                    lat: suggestion.lat,
                                    lng: suggestion.lng
                                },
                                label: label,
                                icon: icon
                            }
                        };
                    });
                    _this.setState({
                        options: [_this.currentLocationOption].concat(suggestions)
                    });
                });
            }
            _this.setState({
                options: [_this.currentLocationOption]
            });
        };
        _this.selectCurrentLocation = function () {
            _this.handleChange(_this.currentLocationOption.value);
        };
        _this.loadOptions = debounce(_this.loadOptions, 500);
        var formatMessage = props.formatMessage;
        var label = formatMessage({ id: "geolocation.components.geoInput.label.useCurrentLocation" });
        var icon = React.createElement(Icon, { color: greys.black, icon: "geoArrow", size: 12 });
        _this.currentLocationOption = {
            label: label,
            icon: icon,
            value: {
                latLng: null,
                label: label,
                icon: icon
            }
        };
        _this.state = {
            value: props.value,
            isFetchingLocation: false,
            options: [_this.currentLocationOption]
        };
        return _this;
    }
    GeoInput.prototype.render = function () {
        var _a = this.state, isFetchingLocation = _a.isFetchingLocation, options = _a.options, value = _a.value;
        return (React.createElement(StyledSelect, __assign({}, this.props, { isLoading: isFetchingLocation, options: options, onChange: this.handleChange, onInputChange: this.loadOptions, id: id("geo-input", this.props), value: value, filterOptions: false })));
    };
    GeoInput.defaultProps = {
        label: null,
        placeholder: "geolocation.components.geoInput.defaultProps.placeholder",
        autoload: false,
        name: "geoInput",
        valueKey: "value",
        labelKey: "label",
        value: null,
        loadingPlaceholder: "geolocation.components.geoInput.defaultProps.loadingPlaceholder",
        optionRenderer: function (selection) { return React.createElement(CustomRenderer, { selection: selection }); },
        valueRenderer: function (selection) { return React.createElement(CustomRenderer, { selection: selection }); },
        arrowRenderer: null,
        useCurrentPositionFallback: true
    };
    return GeoInput;
}(React.Component));
export default injectIntl(GeoInput, { withRef: true });
var templateObject_1;
